import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6 lg:px-12">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <span className={`text-xl md:text-2xl font-bold font-heading transition-colors duration-300 ${
              isScrolled ? 'text-foreground-950' : 'text-white'
            }`}>
              一起草在线观看
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors duration-300 whitespace-nowrap cursor-pointer ${
                isScrolled
                  ? 'text-foreground-700 hover:text-primary-500'
                  : 'text-white/90 hover:text-white'
              } ${location.pathname === '/' ? (isScrolled ? 'text-primary-500' : 'text-white') : ''}`}
            >
              首页
            </Link>
            {categories.slice(0, 4).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`text-sm font-medium transition-colors duration-300 whitespace-nowrap cursor-pointer ${
                  isScrolled
                    ? 'text-foreground-700 hover:text-primary-500'
                    : 'text-white/90 hover:text-white'
                } ${location.pathname === `/category/${cat.slug}` ? (isScrolled ? 'text-primary-500' : 'text-white') : ''}`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors duration-300 whitespace-nowrap cursor-pointer ${
                isScrolled
                  ? 'text-foreground-700 hover:text-primary-500'
                  : 'text-white/90 hover:text-white'
              } ${location.pathname === '/about' ? (isScrolled ? 'text-primary-500' : 'text-white') : ''}`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className={`relative ${
              isScrolled ? 'text-foreground-600' : 'text-white/80'
            }`}>
              <i className="ri-search-line text-lg cursor-pointer hover:text-primary-500 transition-colors duration-300"></i>
            </div>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer transition-colors duration-300 ${
              isScrolled ? 'text-foreground-950' : 'text-white'
            }`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200">
            <div className="flex flex-col py-3 px-4 gap-2">
              <Link to="/" className="py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 cursor-pointer whitespace-nowrap">
                首页
              </Link>
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
              <Link to="/about" className="py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 cursor-pointer whitespace-nowrap">
                关于我们
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}